import { render } from "./DescriptionRefObjCom.vue?vue&type=template&id=2354e81e"
import script from "./DescriptionRefObjCom.vue?vue&type=script&lang=js"
export * from "./DescriptionRefObjCom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__